import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getUserMeAPI } from '../services/apis/userAuthAPI.ts';
import { useAuthStore } from '../services/store';
import { applyLanguageFromApi, getLanguageFromUrl } from '../utils/i18n.ts';

export const useApiLanguage = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { search } = useLocation();
  const urlLanguage = getLanguageFromUrl(search);

  useEffect(() => {
    if (!enabled) return;

    if (urlLanguage) {
      applyLanguageFromApi(urlLanguage);
      return;
    }

    if (!isAuthenticated) return;

    let cancelled = false;

    getUserMeAPI()
      .then((response) => {
        if (!cancelled) {
          applyLanguageFromApi(response.data.language);
        }
      })
      .catch(() => {
        // Keep JWT/replay language already applied during i18n init.
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, isAuthenticated, urlLanguage]);
};
